import { defineStore } from 'pinia'
import { useRoute } from 'vue-router'
import useProductListingSortRoutes from '~/composables/utils/product-listing/sort/use-product-listing-sort-routes'
import { DEFAULT_PER_PAGE } from '~/composables/utils/product-listing/pagination/constants'

export const useProductListingPaginationStore = defineStore(
  'productListingPaginationStore',
  () => {
    const route = useRoute()

    const { sortAndBuildUrlQuery } = useProductListingSortRoutes()

    function hasRoomForMoreProducts(
      visibleProducts: number,
      totalProducts: number
    ): boolean {
      const currentPage = Number(route.query.page)
      const maxPageLimit = Math.ceil(totalProducts / DEFAULT_PER_PAGE)

      return (
        visibleProducts < totalProducts &&
        (currentPage ? currentPage < maxPageLimit : true)
      )
    }

    function isValidPage(totalProducts: number) {
      const currentPage = Number(route.query.page)
      const maxPageLimit = Math.ceil(totalProducts / DEFAULT_PER_PAGE)

      return currentPage <= maxPageLimit
    }

    function onPageChange(updatePage: number) {
      const allQueries = {
        ...route.query,
        page: updatePage,
      }

      sortAndBuildUrlQuery(allQueries)
    }

    return {
      hasRoomForMoreProducts,
      isValidPage,
      onPageChange,
    }
  }
)
